import { Component,Input, OnInit } from '@angular/core';
import { tap } from 'rxjs';
import { saveAs } from 'file-saver';
import { FileDownloader } from "../types/file-downloader";

@Component({
  selector: 'downloadable-file',
  templateUrl: './downloadable-file.component.html'
})
export class DownloadableFileComponent implements OnInit {

    /**
     * Gets or sets the display name of the file to be downloaded.
     */
    @Input() displayName : string;

    /**
     * Gets or sets the file-download service which will be used to download the file.
     */
    @Input() downloader : FileDownloader

    downloadFile(ev : Event) {
        ev.preventDefault();

        this.downloader.getFileDownload()
            .pipe(tap(x => saveAs(x, this.displayName)))
            .subscribe();
    }

    ngOnInit(): void { }
}
